import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Add_Employee = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    comp_name: '',
    mail: '',
    mobile: '',
    emp_code: '',
    dept_name: '',
    designation_name: '',
    location_name: '',
    grade: '',
    report_mngr: '',
    bank_name: '',
    bank_accnum: '',
    ifsc_code: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try{
        const token = localStorage.getItem('authToken');
        if (!token) return;
        const response = await fetch(`${API_BASE_URL}postemployee`, {
            method: 'POST',
            headers: {
              Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(formData),
        });
        const result = await response.json();

        if(result.status){
          toast.success('Employee Successfully Added');
          navigate('/manage_employee');

        } else {
          toast.error(result.error || "An Error Occured while adding employee");
        }
        

    } catch (err) {
        console.error('Request error ',err);
    } finally {
        setIsSubmitting(false);
    }

    
  };

  const handleBackClick = () => {
    navigate('/manage_employee');
  };

  return (
    <div className="hold-transition sidebar-mini layout-fixed" style={{ fontSize: '12px' }}>
      <div className="wrapper">
        <Header />
        <Sidebar />

        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1 className="m-0">Add Employee Form</h1>
                </div>
                <div className="col-sm-6">
                  <ol className="breadcrumb float-sm-right">
                    <li className="breadcrumb-item"><a href="/dashboard">Home</a></li>
                    <li className="breadcrumb-item"><a href="/manage_employee">Employee Details</a></li>
                    <li className="breadcrumb-item active">Add Employee Form</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <section className="col-lg-12">
            <div className="card" style={{ borderTop: '3px solid #00c0ef' }}>
              <div className="box box-info">
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="box-body">
                      <div className="row">
                        <div className="col-md-4 form-group">
                          <label htmlFor="comp_name">Name</label>
                          <input
                            type="text"
                            name="comp_name"
                            id="comp_name"
                            value={formData.comp_name}
                            onChange={handleChange}
                          className="form-control input-font"
                            placeholder="Name"
                            required
                          />
                        </div>
                        <div className="col-md-4 form-group">
                          <label htmlFor="mail_id">Email</label>
                          <input
                            type="email"
                            name="mail_id"
                            id="mail_id"
                            value={formData.mail_id}
                            onChange={handleChange}
                            className="form-control input-font"
                            placeholder="Email"
                            required
                          />
                        </div>
                        <div className="col-md-4 form-group">
                          <label htmlFor="mobile">Mobile</label>
                          <input
                            type="number"
                            name="mobile"
                            id="mobile"
                            value={formData.mobile}
                            onChange={handleChange}
                            className="form-control input-font"
                            placeholder="Mobile"
                            required
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-4 form-group">
                          <label htmlFor="emp_code">BM ID</label>
                          <input
                            type="number"
                            name="emp_code"
                            id="emp_code"
                            value={formData.emp_code}
                            onChange={handleChange}
                            className="form-control input-font"
                            placeholder="Emp Code"
                            required
                          />
                        </div>
                        <div className="col-md-4 form-group">
                          <label htmlFor="dept_name">Dept</label>
                          <input
                            type="text"
                            name="dept_name"
                            id="dept_name"
                            value={formData.dept_name}
                            onChange={handleChange}
                            className="form-control input-font"
                            placeholder="Department"
                            required
                          />
                        </div>
                        <div className="col-md-4 form-group">
                          <label htmlFor="designation_name">Designation</label>
                          <input
                            type="text"
                            name="designation_name"
                            id="designation_name"
                            value={formData.designation_name}
                            onChange={handleChange}
                            className="form-control input-font"
                            placeholder="Designation"
                            required
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-4 form-group">
                          <label htmlFor="location_name">Location</label>
                          <input
                            type="text"
                            name="location_name"
                            id="location_name"
                            value={formData.location_name}
                            onChange={handleChange}
                            className="form-control input-font"
                            placeholder="Location"
                            required
                          />
                        </div>
                        <div className="col-md-4 form-group">
                          <label htmlFor="grade">Band</label>
                          <input
                            type="text"
                            name="grade"
                            id="grade"
                            value={formData.grade}
                            onChange={handleChange}
                            className="form-control input-font"
                            placeholder="grade"
                            required
                          />
                        </div>
                        <div className="col-md-4 form-group">
                          <label htmlFor="report_mngr">Reportint Manager BM Id</label>
                          <input
                            type="text"
                            name="report_mngr"
                            id="report_mngr"
                            value={formData.report_mngr}
                            onChange={handleChange}
                            className="form-control input-font"
                            placeholder="report_mngr"
                            required
                          />
                        </div>
                      </div>


                      <div className="row">
                        <div className="col-md-4 form-group">
                          <label htmlFor="bank_name">Bank</label>
                          <input
                            type="text"
                            name="bank_name"
                            id="bank_name"
                            value={formData.bank_name}
                            onChange={handleChange}
                            className="form-control input-font"
                            placeholder="bank name"
                            required
                          />
                        </div>
                        <div className="col-md-4 form-group">
                          <label htmlFor="bank_accnum">Bank Acc No</label>
                          <input
                            type="text"
                            name="bank_accnum"
                            id="bank_acnum"
                            value={formData.bank_accnum}
                            onChange={handleChange}
                            className="form-control input-font"
                            placeholder="bank_acnum"
                            required
                          />
                        </div>
                        <div className="col-md-4 form-group">
                          <label htmlFor="ifsc_code">IFSC Code</label>
                          <input
                            type="text"
                            name="ifsc_code"
                            id="ifsc_code"
                            value={formData.ifsc_code}
                            onChange={handleChange}
                            className="form-control input-font"
                            placeholder="ifsc_code"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="box-footer text-center">
                      <div className="row justify-content-center">
                        <div className="col-auto">
                          <button
                            type="submit"
                            className="btn btn-success"
                            disabled={!formData.emp_code || isSubmitting}
                          >
                            {isSubmitting ? 'Submitting...' : 'Submit'}
                          </button>
                        </div>
                        <div className="col-auto">
                          <button type="button" className="btn btn-secondary" onClick={handleBackClick}>
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </div>

        <Footer />

        <aside className="control-sidebar control-sidebar-dark" />
      </div>

      <ToastContainer />
    </div>
  );
};

export default Add_Employee;
